import { h, createContext } from 'preact';
import { useContext, useState } from 'preact/hooks';
import getDrawerCategories from './components/util/getDrawerCategories';

const Context = createContext();

export const useDrawer = () => useContext(Context);

export const DrawerContext = ({ children, data }) => {
  // loop through tabs and call getDrawerCategories on each tab
  // if drawerCategory is null, remove tab from tabs array
  const drawerCategories = ['Handle', 'Blade', 'Hardware'].filter((tab) =>
    getDrawerCategories(window.customTag || data.customTag, tab),
  );

  if (drawerCategories.length === 0) {
    // eslint-disable-next-line no-console
    console.warn(
      'No drawer categories configured for',
      window.customTag || data.customTag,
    );
  }

  const [drawerName, setDrawerName] = useState(drawerCategories[0]);
  const [drawerCategory, setDrawerCategory] = useState('');

  function openDrawer(drawerName) {
    setDrawerName(drawerName);
  }

  function closeDrawer() {
    setDrawerName(null);
  }

  return (
    <Context.Provider
      value={{
        drawerName,
        openDrawer,
        closeDrawer,
        drawerCategory,
        setDrawerCategory,
        drawerCategories,
      }}
    >
      {children}
    </Context.Provider>
  );
};
